import { Injectable } from '@angular/core';

import { BetslipError } from '../../../errors/betslip-error';
import { NotLoggedInValidator } from '../../validators/betslip/not-logged-in.validator';

@Injectable()
export class PreBetPlacementValidationService {
    constructor(private notLoggedInValidator: NotLoggedInValidator) {}

    validatePreBetPlacement(): BetslipError[] {
        const notLoggedErrors = this.notLoggedInValidator.validate();

        return [...notLoggedErrors];
    }
}
